export default __webpack_public_path__ + "static/media/future-house.365a7136.png";